import { fetchApiHub } from 'frontastic';

export const testCall = async (payload: any) => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/testCall', { method: 'POST' }, payload);
    return response;
  } catch (error) {
    console.error('Error in testCall:', error);
    throw error;
  }
};

export const mergeProductVariantsIntoOneProduct = async () => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/mergeProductVariantsIntoOneProduct', { method: 'POST' });
    return response;
  } catch (error) {
    console.error('Error in mergeProductVariantsIntoOneProduct:', error);
    throw error;
  }
};

export const getMe = async () => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/getMe', { method: 'POST' });
    return response;
  } catch (error) {
    console.error('Error in getMe:', error);
    throw error;
  }
};

export const getOrders = async (payload) => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/getOrders', { method: 'POST' }, payload);
    return response;
  } catch (error) {
    console.error('Error in getOrders:', error);
    throw error;
  }
};

export const getProductsFromProductSelection = async (payload) => {
  try {
    const response: any = await fetchApiHub(
      '/action/asioProvider/getProductsFromProductSelection',
      { method: 'POST' },
      payload,
    );
    return response;
  } catch (error) {
    console.error('Error in getProductsFromProductSelection:', error);
    throw error;
  }
};

export const getProductSelection = async () => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/getProductSelection', { method: 'POST' });
    return response;
  } catch (error) {
    console.error('Error in getProductSelection:', error);
    throw error;
  }
};

export const myStores = async () => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/myStores', { method: 'POST' });
    return response;
  } catch (error) {
    console.error('Error in myStores:', error);
    throw error;
  }
};

export const addAddresses = async (payload) => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/addAddresses', { method: 'POST' }, payload);
    return response;
  } catch (error) {
    console.error('Error in addAddresses:', error);
    throw error;
  }
};

export const asioChangePassword = async (payload) => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/changePassword', { method: 'POST' }, payload);
    return response;
  } catch (error) {
    console.error('Error in changePassword:', error);
    throw error;
  }
};

export const asioUpdateProfileInfo = async (payload) => {
  try {
    const response: any = await fetchApiHub('/action/asioProvider/updateProfileInfo', { method: 'POST' }, payload);
    return response;
  } catch (error) {
    console.error('Error in updateProfileInfo:', error);
    throw error;
  }
};
